import {Doughnut} from "react-chartjs-2";
import {ArcElement, Chart as ChartJS, Legend, registerables, Tooltip} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import {DashboardDoughnutChartDataElementType} from "../../../interface";

ChartJS.register(...registerables);
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

interface Props {
    title: string
    data: DashboardDoughnutChartDataElementType[]
}

export default function DoughnutChart({title, data}: Props) {
    const colorList = ['#1B829A', '#1CA1BB', '#1CC4E8', '#16958A', '#1CBEB1', '#1DD9C9', '#1676E1', '#1663B8', '#547FE3', '#3862C4'];

    const centerTextPlugin = {
        id: "centerText",
        beforeDraw: (chart: any) => {
            const {ctx, chartArea} = chart;
            if (!chartArea && data.length === 0) return;

            const {left, right, top, bottom} = chartArea;
            const centerX = (left + right) / 2;
            const centerY = (top + bottom) / 2;

            const text = title;

            // 차트 크기가 일정 이하로 작아지면 텍스트를 숨김
            const width = right - left;
            const height = bottom - top;

            // 텍스트가 보일 최소 차트 크기 설정
            const showText = width > 150 && height > 150;

            if (showText) {
                ctx.save();
                ctx.font = `16px NotoSansKR-Medium`;
                ctx.fillStyle = "#000";
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.fillText(text, centerX, centerY);
                ctx.restore();
            }
        },
    };

    const options: any = {
        responsive: true,
        responsiveAnimationDuration: 0.1,
        maintainAspectRatio: false,
        layout: {
            padding: 0,
        },
        plugins: {
            datalabels: {
                display: true,
                color: "white",
                formatter: (value: any, ctx: any) => {
                    const total = ctx.dataset.data.reduce((acc: number, val: number) => acc + Number(val ?? 0), 0);
                    const percentage = (value / total) * 100;

                    // 퍼센트가 15% 이상일 때만 표시하고, 차트 크기가 작으면 텍스트를 숨김
                    if (percentage >= 15) {
                        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }

                    return "";
                },
                font: {
                    size: "12px",
                },
                anchor: "center",
                align: "center",
            },
            legend: {
                display: true,
                position: "right",
                labels: {
                    usePointStyle: true,
                    pointStyle: "rectRounded",
                },
            },
        },
        onResize: (chart: any) => {
            if (chart.width < 300) {
                chart.options.plugins.legend.position = "bottom";
            } else {
                chart.options.plugins.legend.position = "right";
            }
            chart.update();
        },
        elements: {
            arc: {
                borderWidth: 0,
            },
        },
    };

    const myData = {
        labels: data.map(el => el.newName) as any,
        datasets: [
            {
                data: data.map(el => el.percentage) as any,
                backgroundColor: data.map((_, idx) => colorList[idx % colorList.length]) as any,
            },
        ],
    }

    const plugins: any[] = [ChartDataLabels, centerTextPlugin]

    return <Doughnut data={myData} options={options} plugins={plugins}/>
}